module.exports = __webpack_public_path__ + "img/color_summer_clothes.eadd6057.png";